import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import { FiInbox } from "react-icons/fi";
import { T } from "../../constants/todoTokens";
import FullTaskCard from "./FullTaskCard";

const DayView = ({ activeDate, taskMap, direction, onTaskClick, onArchive, onDelete, isAdmin, currentUserId, onAssigneeStatusChanged }) => {
  const key   = activeDate.format("YYYY-MM-DD");
  const tasks = taskMap[key] || [];

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={key}
        initial={{ opacity: 0, x: direction * 30 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: direction * -30 }}
        transition={{ duration: 0.2, ease: [0.22, 1, 0.36, 1] }}
      >
        <Box sx={{ p: { xs: 1.5, sm: 2 }, minHeight: 300 }}>
          {tasks.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 8 }}>
              <Box
                sx={{
                  width: 56, height: 56, borderRadius: "16px",
                  bgcolor: "#F1F5F9",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  mx: "auto", mb: 2,
                }}
              >
                <FiInbox size={24} color="#CBD5E1" />
              </Box>
              <Typography sx={{ fontSize: "14px", fontWeight: 700, color: T.textSub }}>
                No tasks on this day
              </Typography>
              <Typography sx={{ fontSize: "12px", color: T.textMuted, mt: 0.5 }}>
                Navigate to another day or switch to Schedule view
              </Typography>
            </Box>
          ) : (
            <Stack spacing={1.5}>
              {tasks.map((task, i) => (
                <FullTaskCard key={task._id} task={task} index={i} onClick={onTaskClick} onArchive={onArchive} onDelete={onDelete} isAdmin={isAdmin} currentUserId={currentUserId} onAssigneeStatusChanged={onAssigneeStatusChanged} />
              ))}
            </Stack>
          )}
        </Box>
      </motion.div>
    </AnimatePresence>
  );
};

export default React.memo(DayView);
